import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { SparePart } from '@/types'

export interface CartItem {
  partId: string
  quantity: number
  part: SparePart
}

interface CartState {
  items: CartItem[]
  addItem: (part: SparePart, quantity: number) => void
  removeItem: (partId: string) => void
  updateQuantity: (partId: string, quantity: number) => void
  clearCart: () => void
  totalItems: () => number
  totalAmount: () => number
}

export const useCartState = create<CartState>()(
  persist(
    (set, get) => ({
      items: [],
      addItem: (part, quantity) => {
        set((state) => {
          const existing = state.items.find((i) => i.partId === part.id)
          let next: CartItem[]
          if (existing) {
            next = state.items.map((i) =>
              i.partId === part.id
                ? { ...i, quantity: i.quantity + quantity }
                : i
            )
          } else {
            next = [...state.items, { partId: part.id, quantity, part }]
          }
          return { items: next }
        })
      },
      removeItem: (partId) => {
        set((state) => ({ items: state.items.filter((i) => i.partId !== partId) }))
      },
      updateQuantity: (partId, quantity) => {
        if (quantity <= 0) {
          get().removeItem(partId)
          return
        }
        set((state) => ({
          items: state.items.map((i) =>
            i.partId === partId ? { ...i, quantity } : i
          ),
        }))
      },
      clearCart: () => set({ items: [] }),
      totalItems: () => get().items.reduce((acc, i) => acc + i.quantity, 0),
      totalAmount: () =>
        get().items.reduce((acc, i) => acc + (i.part.price ?? 0) * i.quantity, 0),
    }),
    { name: 'oriental-ramirez-cart' }
  )
)
